@let isEditMode = service.isEditMode();

<div class="schedule-table-part">

	<table cellspacing="0" class="white-box mt-3 mb-3 w-100">
		<thead>
			<tr>
				<td></td> <!-- Empty top-left cell -->
				@for(day of dayIndices; track day; let idx= $index){
				<td class="py-2 px-0" role="button" (click)="toggleDaySelection(day)">{{ commonLabels.DayNamesMap.short[day]()
					}}
				</td>
				}
			</tr>
		</thead>
		<tbody>
			@for(hour of hourNames(); track hour; let hour_idx= $index){
			<tr>
				<td class="px-1" role="button" (click)="toggleHourSelection(hour_idx)">{{ hour }}</td>

				@for(day_idx of dayIndices; track day_idx;) {
				@if(isEditMode){
				<td class="p-0" role="button" (click)="toggleSelection(day_idx, hour_idx)" [class.disabled]="blockoutArr[day_idx]?.[hour_idx]">

					@if(selectedSlotsArr[day_idx]?.[hour_idx]){
					<div class="square selected">
						<i class="fa-regular fa-check"></i>
					</div>

					}@else if(impliedSelectedArr[day_idx]?.[hour_idx]) {
					<div class="square implied-selected">
						<i class="fa-solid fa-check"></i>
					</div>

					}@else {
					<div class="square"></div>
					}
				</td>

				} @else {
				<td class="p-0" role="button" [class.disabled]="blockoutArr[day_idx]?.[hour_idx]">
					@if(selectedSlotsArr[day_idx]?.[hour_idx]){
					<i class="fa-regular fa-check fs-4"></i>
					} @else if(impliedSelectedArr[day_idx]?.[hour_idx]) {
					<div class="implied-selected"><i class="fa-regular fa-check"></i></div>
					}
				</td>
				}
				}
			</tr>
			}
		</tbody>
	</table>

	@if(isEditMode){
	<common-button-row [center]="true" class="gap-1">
		<button class="btn btn-primary" (click)="saveChanges()">Save</button>
		<button class="btn btn-standard" (click)="initData()">Revert</button>
		<button class="btn btn-standard" (click)="onCancel()">Cancel</button>
	</common-button-row>
	}
</div>